const ApiUrl = () => {

    let link = '';
    if ( window.location.hostname === 'localhost') {
        // link = 'http://localhost/api'
        link = 'https://api.pietrowicewielkie.com.pl/api'
    }else{
        link = 'https://api.pietrowicewielkie.com.pl/api'
    }

    return link;
}

export default ApiUrl;